import "./index.css";
import Pagination from "react-bootstrap/Pagination";
import React from "react";

function MediaPickerPagination(props) {
  const { onChange, pageIndex, pageSize, totalCount  } = props;
  const finalPage = Math.ceil(totalCount / pageSize);
  const handleChange = (action) => {
    let navigateTo = 1;
    switch (action) {
      case "first":
        navigateTo = 1;
        break;
      case "prev":
        navigateTo = pageIndex !== 1 ? pageIndex - 1 : pageIndex;
        break;
      case "next":
        navigateTo = pageIndex !== finalPage ? pageIndex + 1 : pageIndex;
        break;
      case "last":
        navigateTo = finalPage;
        break;
      default:
        break;
    }
    onChange(navigateTo);
  };
  const pageNumbers = `showing ${pageIndex} of ${finalPage} pages`;
  if (props.fromAssessment || props.fromSurvey){
    return (
      <Pagination>
        <div style={{ marginTop: "7px", marginRight: "7px", color: "grey" }}>
          {pageNumbers}
        </div>
        <Pagination.First
        onClick={() => handleChange("first")}
        style={{ opacity: pageIndex === 1 ? 0.3 : 1, pointerEvents: pageIndex === 1 ? 'none' : 'auto' }}
      />
      <Pagination.Prev
        onClick={() => handleChange("prev")}
        style={{ opacity: pageIndex === 1 ? 0.3 : 1, pointerEvents: pageIndex === 1 ? 'none' : 'auto' }}
      />
       <Pagination.Next
        onClick={() => handleChange("next")}
        style={{ opacity: pageIndex === finalPage ? 0.3 : 1 ,pointerEvents: pageIndex === finalPage ? 'none' : 'auto'}}
      />
        <Pagination.Last
        onClick={() => handleChange("last")}
        style={{ opacity: pageIndex === finalPage ? 0.3 : 1 ,pointerEvents: pageIndex === finalPage ? 'none' : 'auto'}}
      />
      </Pagination>
    );
  }
 
  else{
    return (
      <Pagination>
        <div style={{ marginTop: "7px", marginRight: "7px", color: "grey" }}>
          {pageNumbers}
        </div>
        {props.totalCount > 20 ? (
          <Pagination.First onClick={() => handleChange("first")} />
        ) : (
          <Pagination.First />
        )}
        {props.totalCount > 20 ? (
          <Pagination.Prev onClick={() => handleChange("prev")} />
        ) : (
          <Pagination.Prev />
        )}
        {props.totalCount > 20 ? (
          <Pagination.Next onClick={() => handleChange("next")} />
        ) : (
          <Pagination.Next />
        )}
        {props.totalCount > 20 ? (
          <Pagination.Last onClick={() => handleChange("last")} />
        ) : (
          <Pagination.Last />
        )}
      </Pagination>
    );
  }
  
}

export default MediaPickerPagination;
